(ns frontend.view.settings2.kyc.event
  (:require
   [frontend.view.settings2.kyc.model :as model]
   [re-frame.core :as rf]
   [frontend.state.current-session :as session]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [common.schema.entities.workspace.kyc.automated-renewal.configuration :as c-config]
   [potpuri.core :as p]
   [common.localization :as loc]))

(def inject-tenant-interceptor
  (rf/->interceptor
   {:id     ::inject-tenant
    :before (fn [args]
              (let [tenant @session/tenant]
                (assoc-in args [:coeffects :tenant] tenant)))}))

(rf/reg-event-fx
 ::get-email-templates-done
 [rf/trim-v]
 (fn [{:keys [db]} [_success? resp]]
   {:db (assoc-in db (conj model/root-path :email-templates) (:body resp))}))

(rf/reg-event-fx
 ::get-email-templates
 (fn [_]
   {::ws/send {:id :tenant/get-email-templates
               :on-success [::get-email-templates-done true]
               :on-error [::get-email-templates-done false]}}))

(rf/reg-event-fx
 ::init-editor
 [inject-tenant-interceptor]
 (fn [{:keys [db tenant]}]
   (let [automated-renewal-enabled? (-> tenant
                                        :tenant/automated-kyc-renewal-enabled?
                                        boolean)
         configuration (or (:tenant/automated-kyc-renewal-configuration tenant)
                           (c-config/get-tenant-default-configuration tenant))
         configuration (c-config/merge-config-with-hard-coded-email-subject-and-template tenant configuration)]
     {:db (-> db
              (assoc-in model/automated-renewal-enabled-full-path automated-renewal-enabled?)
              (assoc-in model/configuration-full-path configuration))
      :fx [[:dispatch [::get-email-templates]]]})))

(rf/reg-event-db
 ::set-reminder-interval-value
 [rf/trim-v]
 (fn [db [reminder-index value]]
   (let [path (concat model/reminder-config-full-path [:reminders reminder-index :after :value])]
     (assoc-in db path value))))

(rf/reg-event-db
 ::set-reminder-interval-unit
 [rf/trim-v]
 (fn [db [reminder-index unit]]
   (let [path (concat model/reminder-config-full-path [:reminders reminder-index :after :unit])]
     (assoc-in db path unit))))

(rf/reg-event-fx
 ::save-changes-done
 [rf/trim-v]
 (fn [{:keys [db]} [success? _resp]]
   (merge
    {:db (p/dissoc-in db model/saving-full-path)}
    (when-not success?
      {::toast/error (loc/tr :an-error-occurred)}))))

(rf/reg-event-fx
 ::save-changes
 (fn [{:keys [db]}]
   (let [enabled? (get-in db model/automated-renewal-enabled-full-path)
         configuration (get-in db model/configuration-full-path)]
     {:db (assoc-in db model/saving-full-path true)
      ::ws/send {:id :tenant/update-automated-kyc-renewal-settings
                 :body {:enabled? enabled?
                        :configuration configuration}
                 :on-success [::save-changes-done true]
                 :on-error [::save-changes-done false]}})))

(rf/reg-event-db
 ::toggle-reminders-enabled
 (fn [db]
   (update-in db (conj model/reminder-config-full-path :enabled?) not)))

(rf/reg-event-db
 ::open-reminder-email-preview
 [rf/trim-v]
 (fn [db [reminder-index]]
   (let [lang-path (conj model/root-path :reminder-email-lang)
         prev-lang (get-in db lang-path)
         lang (or prev-lang :en)]
     (-> db
         (assoc-in (conj model/root-path :reminder-email-preview) reminder-index)
         (assoc-in lang-path lang)))))

(rf/reg-event-db
 ::set-reminder-email-preview-lang
 [rf/trim-v]
 (fn [db [lang-kw]]
   (assoc-in db (conj model/root-path :reminder-email-lang) lang-kw)))

(rf/reg-event-db
 ::close-reminder-email-preview
 [rf/trim-v]
 (fn [db]
   (p/dissoc-in db (conj model/root-path :reminder-email-preview))))
